import React from "react";
import '../Css/Terms & conditions.css';

function Terms_Conditions(){
    return(
        <section className="termsHolder">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>Terms and Conditions</h1>
                        <p>Welcome to 4 Wheel Barbers, a mobile barbering service providing professional haircuts and grooming services at your convenience. By booking and using our services, you agree to the following terms and conditions.</p>
            
                        <h2>1. Appointments and Bookings</h2>
                        <p>All appointments must be made through our official booking platform or by contacting us directly. Bookings are subject to availability and will be confirmed upon receipt. Please provide accurate details when booking, including your location and any specific requests.</p>
            
                        <h2>2. Cancellations and Rescheduling</h2>
                        <p>Cancellations or rescheduling must be made at least 24 hours in advance. Cancellations made less than 24 hours before the appointment will incur a cancellation fee of £10.</p>
                        <p>If we need to cancel or reschedule an appointment due to unforeseen circumstances, we will notify you as soon as possible and offer alternative dates or a full refund.</p>
            
                        <h2>3. Service Locations</h2>
                        <p>Our mobile service covers South East London, Kent, and Surrey. Further locations can be discussed with the client, and extra travel costs may apply.</p>
                        <p>Please ensure the location you provide for the appointment is safe, clean, and accessible for our barber to set up. We reserve the right to refuse service if the location is deemed unsuitable.</p>
            
                        <h2>4. Payments</h2>
                        <p>Payment is due upon completion of the service unless agreed otherwise. We accept cash and card payments through most standard card readers.</p>
                        <p>Prices for services are subject to change. You will be informed of any price adjustments prior to your appointment.</p>
            
                        <h2>5. Client Responsibilities</h2>
                        <p>Please ensure that your hair is clean and ready for the haircut or grooming service at the time of your appointment. If you are feeling unwell, kindly reschedule your appointment to ensure the safety of our staff and other clients.</p>
            
                        <h2>6. Liability</h2>
                        <p>4 Wheel Barbers will not be held liable for any allergic reactions or skin sensitivities related to the products used during the service. Please inform your barber in advance if you have any allergies or sensitivities.</p>
                        <p>We are not responsible for any damage caused to your property during the service unless it is due to negligence on our part.</p>
            
                        <h2>7. Complaints and Feedback</h2>
                        <p>If you are not satisfied with our service, please notify us immediately. We will do our best to resolve any issues.</p>
                        <p>Feedback is important to us. Feel free to share your experience with us through our contact page.</p>
            
                        <h2>8. Privacy Policy</h2>
                        <p>Any personal information you provide during the booking process will be kept confidential and used only for the purpose of providing our services. We do not share your personal information with third parties without your consent.</p>
            
                        <h2>9. Amendments</h2>
                        <p>We reserve the right to update these terms and conditions at any time. Any changes will be posted on our website, and it is your responsibility to review them before booking a service.</p>
            
                        <h2>Contact Us</h2>
                        <p>If you have any questions or concerns regarding our terms and conditions, please contact us at <a href="mailto:4wheelbarbers@yahoo.com">4wheelbarbers@yahoo.com</a>.</p>
                    </div>
                </div>
            </div>
        </section>
        
    )
}

export default Terms_Conditions;